

const HomeContent: React.FC =() => {

    return (
        <div>
            <h2>Home</h2>

        </div>
    )
}

export default HomeContent